import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css';

function Testimonial() {
  return (
            <span className="pt-120 pb-100" id="testimonial">
                <section className="testimonial__area pt-120 pb-100">
                    <div className="container-fluid p-0 plr-xs-15">
                        <div className="sec__title text-center mb-60">
                            <span className="sub__title"><i className="fas fa-star"></i>Client Feedback</span>
                            <h2 className="title">Our client & their opinions</h2>
                        </div>
                        {/* <div className=""> */}
                            <OwlCarousel
                                items={2}
                                className={"testimonial__carousel owl-carousel"}
                                margin={30}
                                dots={false}
                                autoplay={true}
                                loop
                                smartSpeed={1000}
                                autoplayTimeout={5000}
                                autoplayHoverPause={true}
                                center={true}
                                stagePadding={200}
                            >
                                <div className="testimonial__item">
                                    <div className="avatar">
                                        <img src="assets/img/avatar/test_01.png" alt="" />
                                    </div>
                                    <h4 className="name">Nnaji Ogechi</h4>
                                    <ul className="ratting__star ul_li_center mb-20">
                                        <li><i className="fas fa-star"></i></li>
                                        <li><i className="fas fa-star"></i></li>
                                        <li><i className="fas fa-star"></i></li>
                                        <li><i className="fas fa-star"></i></li>
                                        <li><i className="fas fa-star"></i></li>
                                    </ul>
                                    <p>"TTN Consulting supported us with an assessment centre that was practical, well-organised, and easy to implement. The process helped us make clearer and more confident hiring decisions."</p>
                                    <div className="testi__quote">
                                        <img src="assets/img/icon/quote.png" alt="" />
                                    </div>
                                </div>
                            <div className="testimonial__item">
                                <div className="avatar">
                                    <img src="assets/img/avatar/test_01.png" alt="" />
                                </div>
                                <h4 className="name">Emmanuel Nkennor</h4>
                                <ul className="ratting__star ul_li_center mb-20">
                                    <li><i className="fas fa-star"></i></li>
                                    <li><i className="fas fa-star"></i></li>
                                    <li><i className="fas fa-star"></i></li>
                                    <li><i className="fas fa-star"></i></li>
                                    <li><i className="fas fa-star"></i></li>
                                </ul>
                                <p>“Working with TTN Consulting was straightforward and professional. Their understanding of recruitment and talent management showed clearly in the quality of candidates we received.”</p>
                                <div className="testi__quote">
                                    <img src="assets/img/icon/quote.png" alt="" />
                                </div>
                            </div>
                            <div className="testimonial__item">
                                <div className="avatar">
                                    <img src="assets/img/avatar/test_01.png" alt="" />
                                </div>
                                <h4 className="name">Oreva Ovuomaye</h4>
                                <ul className="ratting__star ul_li_center mb-20">
                                    <li><i className="fas fa-star"></i></li>
                                    <li><i className="fas fa-star"></i></li>
                                    <li><i className="fas fa-star"></i></li>
                                    <li><i className="fas fa-star"></i></li>
                                    <li><i className="fas fa-star"></i></li>
                                </ul>
                                <p>“TTN Consulting handled our executive recruitment with care and attention to detail. They took time to understand our needs and delivered candidates that were a good fit for our organisation.”</p>
                                <div className="testi__quote">
                                    <img src="assets/img/icon/quote.png" alt="" />
                                </div>
                            </div>
                            <div className="testimonial__item">
                                    <div className="avatar">
                                        <img src="assets/img/avatar/test_01.png" alt="" />
                                    </div>
                                    <h4 className="name">Anonymous</h4>
                                    <ul className="ratting__star ul_li_center mb-20">
                                        <li><i className="fas fa-star"></i></li>
                                        <li><i className="fas fa-star"></i></li>
                                        <li><i className="fas fa-star"></i></li>
                                        <li><i className="fas fa-star"></i></li>
                                        <li><i className="fas fa-star"></i></li>
                                    </ul>
                                    <p>"Excellent Delivery. Very responsive team"</p>
                                    <div className="testi__quote">
                                        <img src="assets/img/icon/quote.png" alt="" />
                                    </div>
                            </div>
                            </OwlCarousel>
                        {/* </div> */}
                    </div>
                </section>
            </span>
  )
}

export default Testimonial
